import { withNamespaces } from "react-i18next";
import { Text, View } from "@react-pdf/renderer";
import styles from "../../Styles";

const CorporateStructure = ({ t, company, financial_summary, management_team }) => {
  const legalAndBusinessDetails = [
    {
      title: "Legal Form Code",
      details: company?.legalForm ?? "-",
    },
    {
      title: "Line of Business",
      details: company?.lineOfBusiness ?? "-",
    },
    {
      title: "SIC Activity Code",
      details: financial_summary?.sicActivityCodes?.length
        ? financial_summary?.sicActivityCodes
            .map((x) => x.code)
            .filter(Boolean)
            .join(", ")
        : "-",
    },
    {
      title: "Description",
      // If you only want one, use: sicCodes?.[0]?.description ?? "-"
      details: financial_summary?.sicActivityCodes?.length
        ? financial_summary?.sicActivityCodes
            .map((x) => x.description)
            .filter(Boolean)
            .join(" | ")
        : "-",
    },
    {
      title: "Local Activity Code",
      details: financial_summary?.localActivityCode ?? "-",
    },
  ];

  const getExecutives = () => {
    const executives = (management_team ?? [])
      .filter((p) => (p?.fullName ?? "").trim().length > 0)
      .map((p) => ({
        title: (p?.positions ?? "").trim() || "Executive",
        name: p.fullName,
      }));

    const keyExecutivesTableRows = executives.map((e) => ({
      title: e.title,
      details: e.name,
    }));

    return keyExecutivesTableRows;
  };

  const keyExecutives = getExecutives();

  return (
    <View style={styles.section} break>
      {/* Section title */}
      <Text style={styles.sectionSeparator}>
        {`${t("4.")} ${t("Corporate Structure & Governance")}`}
      </Text>

      {/* 4.1 */}
      <Text style={styles.alphListItem}>
        {`4.1 ${t("Legal and Business Details")}`}
      </Text>

      <View style={styles.table}>
        {/* header row */}
        <View style={styles.tableRow}>
          <View style={styles.tableColHeader}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("Title")}
            </Text>
          </View>

          <View style={{ ...styles.tableColHeader, ...styles.borderRightNone }}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("Details")}
            </Text>
          </View>
        </View>

        {/* body rows */}
        {legalAndBusinessDetails.map((d, i) => {
          const rowStyle = {
            ...styles.tableRow,
            ...(i === legalAndBusinessDetails.length - 1
              ? styles.tableLastRow
              : {}),
          };

          return (
            <View style={rowStyle} key={i}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{t(d.title)}</Text>
              </View>

              <View style={{ ...styles.tableCol, ...styles.borderRightNone }}>
                <Text style={styles.tableCell}>{d.details ?? "-"}</Text>
              </View>
            </View>
          );
        })}
      </View>

      {/* 4.2 */}
      <Text style={styles.alphListItem}>{`4.2 ${t("Key Executives")}`}</Text>

      <View style={styles.table}>
        {/* header row */}
        <View style={styles.tableRow}>
          <View style={styles.tableColHeader}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("Title")}
            </Text>
          </View>

          <View style={{ ...styles.tableColHeader, ...styles.borderRightNone }}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("Name")}
            </Text>
          </View>
        </View>

        {/* body rows */}
        {keyExecutives.map((d, i) => {
          const rowStyle = {
            ...styles.tableRow,
            ...(i === keyExecutives.length - 1 ? styles.tableLastRow : {}),
          };

          return (
            <View style={rowStyle} key={i}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{t(d.title)}</Text>
              </View>

              <View style={{ ...styles.tableCol, ...styles.borderRightNone }}>
                <Text style={styles.tableCell}>{d.details ?? "-"}</Text>
              </View>
            </View>
          );
        })}
      </View>
    </View>
  );
};

export default withNamespaces()(CorporateStructure);
